import { Component, Injectable, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AbstractEmailComponent } from '../abstract-email/abstract-email.component';
import { AuthService } from '@aiwyn/auth';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { LoadableHelper, LoadableStatus, Logger } from '@aiwyn/shared';
import { ROUTE_TOKEN_LOGIN, ROUTE_TOKEN_MAIN_BASE } from '../../../../routing-constants';

@Injectable({
  providedIn: 'root'
})
export class VerifyEmailGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authService.getAuthProviderUser().pipe(
      filter(({ status }) => LoadableHelper.isLoaded(status, true)),
      map(({ status, data: authProviderUser }) => {
        if (status === LoadableStatus.ERROR || !authProviderUser) {
          return this.router.createUrlTree([ROUTE_TOKEN_LOGIN])
        }

        // If logged in and anonymous, let auth guard handle lifting
        if (authProviderUser.isAnonymous()) {
          return this.router.createUrlTree([ROUTE_TOKEN_MAIN_BASE]);
        }

        return authProviderUser.isEmailVerified() ?
          // If user has already verified, redirect to main
          this.router.createUrlTree([ROUTE_TOKEN_MAIN_BASE]) :
          // Otherwise, let the user continue to the verify email page
          true;
      }),
    );
  }
}

@Component({
  selector: 'app-check-email-for-verification',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
  standalone: false,
})
export class VerifyEmailComponent extends AbstractEmailComponent implements OnInit {

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected authService: AuthService,
    protected logger: Logger,
  ) {
    super(route, router, authService, logger);
  }

  ngOnInit(): void {
    super.init();
  }
}
